/** Lab realtime-invalidated status (invalidRealTimeBet → revalidRealTimeBet). */
export const RT_INVALID_BET_STATUS = 'RT_INVALID_BET'

/** Lab workstation.js default Total(X) / net-expo page commission rate. */
export const DEFAULT_NET_EXPO_PAGE_COMMISSION_RATE = 12

/**
 * Parse Total(X) input (Lab work-station.html allows digits, comma, decimal).
 * Invalid / empty → fallback (Lab getRatesOfTotalMulti default 12).
 */
export function parseNetExpoPageCommissionRate(
  raw: string,
  fallback = DEFAULT_NET_EXPO_PAGE_COMMISSION_RATE,
): number {
  const trimmed = String(raw).replace(/,/g, '').trim()
  if (!trimmed) return fallback
  const n = Number(trimmed)
  return Number.isFinite(n) && n >= 0 ? n : fallback
}

/**
 * Lab setRatesOfTotalMulti success: truthy `value`.
 * CM-API also returns value 0 + message when rate is unchanged — treat as ok.
 */
export function isNetExpoPageCommissionRateSaved(res: {
  value: number
  message?: string
}): boolean {
  if (Number.isFinite(res.value) && res.value > 0) return true
  const msg = (res.message ?? '').toLowerCase()
  return msg.includes('already') || msg.includes('successfully')
}

/**
 * Invalid Bet + revalidate UI — owners always; staff need `invalid-bet` grant.
 * One Access Level checkbox ("Invalid Bet") covers both actions.
 */
export function canManageWorkstationInvalidBets(input?: {
  staffUserId?: string | null
  grants?: string[] | null
}): boolean {
  if (!input?.staffUserId) return true
  return (input.grants ?? []).includes('invalid-bet')
}

/** Old bet-breakdown.html: revalidate icon for RT_INVALID_BET, not Match Odds. */
export function canRevalidateWorkstationBet(bet: {
  status: string
  marketName: string
}): boolean {
  return bet.status === RT_INVALID_BET_STATUS && bet.marketName !== 'Match Odds'
}

/** Old bet-breakdown.html: invalid checkbox when not RT_INVALID_BET, not Match Odds. */
export function canSelectBetForInvalid(bet: { status: string; marketName: string }): boolean {
  return bet.status !== RT_INVALID_BET_STATUS && bet.marketName !== 'Match Odds'
}
